/* https://tyapk.ru/blog/post/correct-way-to-import-lodash-methods */
import get from 'lodash.get';
import { type ReactElement } from 'react';
import arDictionaryContent from 'src/locales/ar.json';
import enDictionaryContent from 'src/locales/en.json';
import {
  type Lang,
  LangDictionary,
  type Locale,
} from 'src/types/lang-locale-type';
import { getLangCode } from 'src/utils/get-lang-code';
import { replaceStringTagToComponent } from 'src/utils/replace-string-tag-to-component';

const dictionaryContent: {
  [key in LangDictionary]: any;
} = {
  [LangDictionary.en]: enDictionaryContent,
  [LangDictionary.ar]: arDictionaryContent,
};

// L10nTool scans comments. Keep this Lokalise plural sibling for the explicit
// `payments_other` key used by the custom translation helper.
// t('payments_one')

const replace = (source = '', target = '', val = '') =>
  source.replace(new RegExp(`{{${target}}}`, 'g'), val);

const getDictionaryName = (
  lang: string | Lang,
  locale: string | Locale
): LangDictionary => getLangCode((lang || locale) as Lang);

const getTranslation = (lang: Lang, locale: Locale, value: string): string => {
  const dictionaryName = getDictionaryName(lang, locale);
  const currentDictionaryContent: LangDictionary =
    dictionaryContent[dictionaryName];

  return get(currentDictionaryContent, value, value);
};

const getTranslationString = (
  lang: Lang,
  locale: Locale,
  value: string,
  params: Record<string, any> | null = null
) => {
  const translation = getTranslation(lang, locale, value);

  if (!params) return translation;

  return Object.keys(params).reduce(
    (prev, key) => replace(prev, key, params[key]),
    translation
  );
};

export const getTranslationFn =
  (lang: Lang, locale: Locale) =>
  (
    value: string,
    params?: Record<string, unknown> | null,
    сomponetsMap?: Record<string, (content?: string) => ReactElement>
  ) => {
    const translationString = getTranslationString(lang, locale, value, params);

    return сomponetsMap
      ? replaceStringTagToComponent(translationString, сomponetsMap)
      : translationString;
  };
